// extracted by mini-css-extract-plugin
export var box = "_46-1";
export var checked = "_46-2";
export var descriptionSpacer = "_46-9";
export var disabled = "_46-3";
export var icon = "_46-6";
export var input = "_46-0";
export var labelSpacer = "_46-8";
export var medium = "_46-5";
export var small = "_46-4";
export var text = "_46-7";